module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('AppTemplate', {
    attrs: {
      "pagetitle": "推广分析",
      "tip": "推广分析报告为您展示应用推广的推广及效果数据帮助您及时了解您的应用推广状态，依据效果数据优化推广账户",
      "currentTab": _vm.currentTab,
      "total": _vm.total,
      "pg": _vm.pg,
      "ps": _vm.ps,
      "tablist": _vm.tablist,
      "tableDataList": _vm.tableDataList,
      "hasCheckBox": _vm.hasCheckBox,
      "checkboxLength": _vm.checkboxLength,
      "sum": _vm.sum,
      "yAxis": _vm.yAxis,
      "legend": _vm.legend,
      "chartXAxis": _vm.chartXAxis,
      "chartSeries": _vm.chartSeries,
      "customIndice": _vm.customIndice,
      "twoIndiceShow": _vm.twoIndiceShow,
      "twoIndice": _vm.twoIndice
    },
    on: {
      "indiceChange": _vm.indiceChange,
      "tableUpdate": _vm.getTableData,
      "clearKeyword": _vm.clearKeyword,
      "tablesorter": _vm.tablesorter
    }
  }, [_c('div', {
    staticClass: "nav-tabs",
    slot: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist,
      "update": _vm.updateTab,
      "currentTab": _vm.currentTab
    }
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": _vm.tableTabTitle,
      "subtitle": ""
    },
    slot: "extentTab"
  }) : _vm._e(), _c('div', {
    slot: "common"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 'planId'),
      expression: "currentTab == 'planId'"
    }],
    staticClass: "plan-nav"
  }, [_vm._v("选择二级维度："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sdim),
      expression: "sdim"
    }],
    attrs: {
      "name": "secondaryDim",
      "options": _vm.sdimOptions
    },
    domProps: {
      "value": (_vm.sdim)
    },
    on: {
      "input": function($event) {
        _vm.sdim = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.sdimChange($event)
      }
    }
  })], 1), _c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")]), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 'advertId'),
      expression: "currentTab == 'advertId'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.planselected),
      expression: "planselected"
    }],
    attrs: {
      "options": _vm.planlistOptions
    },
    domProps: {
      "value": (_vm.planselected)
    },
    on: {
      "input": [function($event) {
        _vm.planselected = $event
      }, _vm.onPlanChange]
    }
  }), _c('Search', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab != 'product'),
      expression: "currentTab != 'product'"
    }],
    attrs: {
      "placeholder": _vm.placeHolder,
      "defaultValue": _vm.keyword
    },
    on: {
      "doSearch": _vm.doSearch
    }
  })], 1)])], 1)], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a3793474", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a3793474!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/app/promotion.vue
// module id = 786
// module chunks = 0